import React, { useState } from "react";
import { Mail } from "lucide-react";

const SidebarSubscribe = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await fetch("/api/newsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Thank you for subscribing!");
        setEmail("");
      } else {
        setMessage(data.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      setMessage("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rounded-md border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-start gap-3">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-sm bg-[rgba(126,34,206,0.08)] text-[rgb(126,34,206)]">
          <Mail className="h-5 w-5" aria-hidden="true" />
        </span>
        <div>
          <h5 className="text-base font-extrabold text-gray-900">
            Weekly PTE insights
          </h5>
          <p className="mt-1 text-sm leading-6 text-gray-500">
            Get PrepNexis updates, exam tips, and study ideas in your inbox.
          </p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="mt-4 space-y-3">
        <input
          type="email"
          id="UserEmail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="w-full rounded-sm border border-slate-200 px-3 py-2.5 text-sm outline-none transition focus:border-[rgba(126,34,206,0.45)] focus:ring-2 focus:ring-[rgba(126,34,206,0.12)]"
          required
        />
        <button
          type="submit"
          className={`w-full rounded-sm bg-[rgba(126,34,206,0.08)] px-4 py-2.5 text-sm font-semibold text-[rgb(126,34,206)] ring-1 ring-[rgba(126,34,206,0.16)] transition hover:bg-[rgba(126,34,206,0.12)] ${
            loading ? "cursor-not-allowed opacity-75" : ""
          }`}
          disabled={loading}
        >
          {loading ? "Signing up..." : "Sign up"}
        </button>
      </form>

      {message && (
        <p
          className={`mt-3 text-sm ${
            message.includes("Thank you") ? "text-green-600" : "text-red-500"
          }`}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default SidebarSubscribe;
